import { combineReducers } from 'redux';

import byId from 'modules/tireQuote/reducers/data/byId';

export default combineReducers({
  byId,
});
